module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "canvas-parent",
    attrs: {
      "id": "pin-chart"
    }
  }, [_c('canvas')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ef77f30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/charts/project.vue
// module id = 403
// module chunks = 14